import { NaturalMiddleSticky } from './controller';
import './styles.css';

const STICKY_SELECTOR = '[data-sticky]';
const BOUND_KEY = 'true';
const STICKY_BOUND_KEY = 'stickyBound';

let initialized = false;
const activeEntries: Array<{ el: HTMLElement; instance: NaturalMiddleSticky }> = [];

export function initSticky(): void {
    if (initialized) return;
    initialized = true;
    document.addEventListener('ui:update', () => {
        activeEntries.forEach(({ el, instance }) => {
            instance.destroy();
            delete el.dataset[STICKY_BOUND_KEY];
        });
        activeEntries.length = 0;
        mount(document);
    });
}

function mount(scope: ParentNode): void {
    const nodes = Array.from(scope.querySelectorAll<HTMLElement>(STICKY_SELECTOR));
    nodes.forEach(el => {
        if (el.dataset[STICKY_BOUND_KEY] === BOUND_KEY) return;
        el.dataset[STICKY_BOUND_KEY] = BOUND_KEY;

        const autoSnapAttr = el.getAttribute('data-auto-snap');
        const autoSnap = autoSnapAttr === 'true' || autoSnapAttr === '';
        const easingAttr = el.getAttribute('data-snap-easing');

        const instance = new NaturalMiddleSticky(el, {
            autoSnap,
            snapTimeout: 500,
            snapDuration: 300,
            snapEasing: easingAttr || 'ease',
        });
        activeEntries.push({ el, instance });
    });
}